// Lib
import { DependencyList, RefObject, useLayoutEffect, useState } from 'react';

/**
 * Returns the browser-computed background colour for a referenced element.
 *
 * This is useful when an element's visible colour is derived from CSS variables
 * or inherited styles rather than an explicit value in React props.
 */
const useComputedBackgroundColor = <T extends HTMLElement>(
    ref: RefObject<T> | null,
    dependencies: DependencyList = [],
): string | null => {
    const [computedColor, setComputedColor] = useState<string | null>(null);

    useLayoutEffect(() => {
        const element = ref?.current;
        if (!element) {
            setComputedColor(null);
            return;
        }

        const backgroundColor = getComputedStyle(element).backgroundColor;

        if (!backgroundColor || backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent') {
            setComputedColor(null);
            return;
        }

        setComputedColor(backgroundColor);
    }, [ref, ...dependencies]);

    return computedColor;
};

export default useComputedBackgroundColor;
